import React, { useEffect, useRef, useState } from "react";

import { Box, CssBaseline } from "@mui/material";

import { showScreen } from "data/mobapp_functions";
import NoSleep from "nosleep.js";
import { Outlet } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";

// import { GetAuthData } from "contexts/TAuthContext";
import { Global } from "@emotion/react";
import { GetCode } from "contexts/CodeContext";
import { isObjectEmpty } from "data/functions";
import { AnimatePresence, motion } from "framer-motion";
import idleTimeout from "idle-timeout";

const drawerBleeding = 24;

function Home() {
  const { code } = GetCode();
  const ref = useRef();
  const location = useLocation();
  const navigate = useNavigate();
  const instance = idleTimeout(
    (element) => {
      if (window.location.pathname !== "/") {
        navigate("/");
      }
      // console.log("idle");
    },
    {
      element: document,
      loop: true,
      timeout: 1000 * 60 * 5,
      // timeout: 1000 * 5,
    }
  );
  const spring = {
    damping: 20,
    mass: 2,
    stiffness: 150,
    type: "spring",
  };

  var noSleep = new NoSleep();

  useEffect(() => {
    try {
      noSleep.enable();
    } catch (error) {}

    return () => noSleep.disable();
  }, [location]);

  useEffect(() => {
    let arrayOfStrings = location.pathname.split("/");
    if (arrayOfStrings[1]) showScreen(arrayOfStrings[1]);
  }, [location]);

  useEffect(() => {
    if (window.location.pathname !== "/") {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (
      !isObjectEmpty(code) &&
      code?.orderUrl !== "" &&
      window.location.pathname !== "/code"
    ) {
      navigate("/code");
    }
  }, [code]);

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Box
          ref={ref}
          sx={{
            flexDirection: "column",
            width: "100%",
          }}
        >
          {
            <AnimatePresence mode="wait">
              <motion.div
                animate={{ opacity: 1 }}
                key={location.pathname}
                style={{
                  height: "100svh",
                  opacity: "0.5",
                }}
                // transition={{ duration: 1 }}
                transition={spring}
              >
                <Outlet />
              </motion.div>
            </AnimatePresence>
          }
        </Box>
      </Box>
      <CssBaseline />
      <Global
        styles={{
          ".MuiDrawer-root > .MuiPaper-root": {
            height: `calc(60% - ${drawerBleeding}px)`,
            overflow: "visible",
          },
        }}
      />
      {/* </Box> */}
    </React.Fragment>
  );
}

export default Home;
